import { NAV_ITEM_TYPE_ITEM } from 'constants/navigation.constant'
import { USER } from 'constants/roles.constant'
import store from '../../store/index'

export function getNavigationConfig(lang) {
    const user = store.getState().auth.user
    const authenticated = Object.keys(user).length > 0

    const navigationConfig = [
        {
            key: 'home',
            path: `/${lang}/home`,
            title: 'Home',
            translateKey: 'navBar:nav.home',
            icon: 'home',
            type: NAV_ITEM_TYPE_ITEM,
            authority: [USER],
            subMenu: [],
        },
        {
            key: 'about-us',
            path: `/${lang}/about-us`,
            title: 'About us',
            translateKey: 'navBar:nav.about-us',
            icon: 'contact',
            type: NAV_ITEM_TYPE_ITEM,
            authority: [],
            subMenu: [],
        },

        {
            key: 'contact',
            path: `/${lang}/contactUs`,
            title: 'Contact Us',
            translateKey: 'navBar:nav.contact',
            icon: 'contact',
            type: NAV_ITEM_TYPE_ITEM,
            authority: [],
            subMenu: [],
        },
        // {
        //     key: 'referrals',
        //     path: `/${lang}/referrals`,
        //     title: 'referrals',
        //     translateKey: 'navBar:nav.referrals',
        //     icon: 'contact',
        //     type: NAV_ITEM_TYPE_ITEM,
        //     authority: [],
        //     subMenu: [],
        // },
        // {
        //     key: 'gdpr',
        //     path: `/${lang}/gdpr`,
        //     title: 'GDPR',
        //     translateKey: 'navBar:nav.gdpr',
        //     icon: 'contact',
        //     type: NAV_ITEM_TYPE_ITEM,
        //     authority: [],
        //     subMenu: [],
        // },
        // {
        //     key: 'terms-and-conditions',
        //     path: `/${lang}/terms-and-conditions`,
        //     title: 'Terms & Conditions',
        //     translateKey: 'navBar:nav.terms-conditions',
        //     icon: 'contact',
        //     type: NAV_ITEM_TYPE_ITEM,
        //     authority: [],
        //     subMenu: [],
        // },
        // {
        //     key: 'privacy-policy',
        //     path: `/${lang}/privacy-policy`,
        //     title: 'Privacy Policy',
        //     translateKey: 'navBar:nav.privacy-policy',
        //     icon: 'contact',
        //     type: NAV_ITEM_TYPE_ITEM,
        //     authority: [],
        //     subMenu: [],
        // },

        authenticated && {
            key: 'dashboard',
            path: `/${lang}/dashboard`,
            title: 'Dashboard',
            translateKey: 'navBar:nav.dashboard',
            icon: 'contact',
            type: NAV_ITEM_TYPE_ITEM,
            authority: [],
            subMenu: [],
        },
        authenticated && {
            key: 'affiliates',
            path: `/${lang}/affiliates`,
            title: 'Affiliates',
            translateKey: 'navBar:nav.affiliates',
            icon: 'contact',
            type: NAV_ITEM_TYPE_ITEM,
            authority: [],
            subMenu: [],
        },
        authenticated && {
            key: 'purchases',
            path: `/${lang}/purchases`,
            title: 'Purchases',
            translateKey: 'navBar:nav.purchases',
            icon: 'purchases',
            type: NAV_ITEM_TYPE_ITEM,
            authority: [],
            subMenu: [],
        },
        authenticated && {
            key: 'my-account',
            path: `/${lang}/my-account/profile`,
            title: 'My Account',
            translateKey: 'navBar:nav.my-account',
            icon: 'my_account',
            type: NAV_ITEM_TYPE_ITEM,
            authority: [],
            subMenu: [],
        },
    ]
    return navigationConfig
}
